"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResourceBrowserContextProvider = exports.ResourceBrowserContext = void 0;
const react_1 = __importStar(require("react"));
const p_memoize_1 = __importDefault(require("p-memoize"));
const expiry_map_1 = __importDefault(require("expiry-map"));
/**
 * @internal Direct usage of this object is discouraged. It will be privated in a future major version.
 * Please use ResourceBrowserContextProvider instead.
 */
exports.ResourceBrowserContext = react_1.default.createContext({
    onRequestSources: () => {
        throw new Error('onRequestSources has not been configured.');
    },
    searchEnabled: false,
    plugins: [],
});
const ResourceBrowserContextProvider = (props) => {
    const CACHE_DURATION = 30000; // 30 seconds
    const { value: { onRequestSources, ...other }, children, } = props;
    const cache = new expiry_map_1.default(CACHE_DURATION);
    const memoized = (0, react_1.useMemo)(() => ({
        onRequestSources: (0, p_memoize_1.default)(onRequestSources, {
            cache,
            cacheKey: () => 'onRequestSources',
        }),
    }), [onRequestSources]);
    return react_1.default.createElement(exports.ResourceBrowserContext.Provider, { value: { ...memoized, ...other } }, children);
};
exports.ResourceBrowserContextProvider = ResourceBrowserContextProvider;
